<script lang="ts">
	// A label pill matching the app's chips: flat, softly tinted with the
	// label color (the Studio chip recipe — gradients are reserved for
	// launcher tiles). Tones map onto the app's log/tag-set colors.
	type Tone = 'green' | 'red' | 'blue' | 'amber';
	let { tone = 'green', children }: { tone?: Tone; children?: import('svelte').Snippet } = $props();

	const color: Record<Tone, string> = {
		green: 'var(--green)',
		red: 'var(--pink)',
		blue: 'var(--blue)',
		amber: 'var(--orange)'
	};
</script>

<span class="pill" style="--pill-c: {color[tone]}">
	{@render children?.()}
</span>
